import {AxiosError} from "axios";
import {ProblemDetails} from "@/@types/base.types.ts";

export type ErrorKey = {
    code: string;
    messageKey: string;
}

type ErrorKeyMap = { [key: string]: ErrorKey };

export const ApiErrorKeys: ErrorKeyMap = {
    unknown: {
        code: "ERR_UNKNOWN",
        messageKey: "error.unknown",
    },
    serviceUnavailable: {
        code: "ERR_SERVICE_UNAVAILABLE",
        messageKey: "error.serviceUnavailable",
    },
    networkError: {
        code: "ERR_NETWORK",
        messageKey: "error.network",
    },
    unauthorized: {
        code: "ERR_UNAUTHORIZED",
        messageKey: "error.unauthorized",
    },
    forbidden: {
        code: "ERR_FORBIDDEN",
        messageKey: "error.forbidden"
    },
    twoFactor: {
        code: "ERR_TWO_FACTOR",
        messageKey: "error.twoFactor"
    },
    userNotFound: {
        code: "ERR_USER_NOT_FOUND",
        messageKey: "error.userNotFound"
    },
    invalidPassword: {
        code: "ERR_INVALID_PASSWORD",
        messageKey: "error.invalidPassword"
    },
    userLockedOut: {
        code: "ERR_USER_LOCKED_OUT",
        messageKey: "error.userLockedOut"
    },
}

export const getErrorKey = (error?: AxiosError<ProblemDetails>): ErrorKey => {
    if (!error) return ApiErrorKeys.unknown;

    if (error.code === 'ERR_NETWORK') return ApiErrorKeys.networkError;
    if ([502, 503, 504].includes(error.response?.status ?? 0)) {
        return ApiErrorKeys.serviceUnavailable;
    }
    if (error.code === 'ERR_BAD_REQUEST') {
        return ApiErrorKeys.unknown; // Handle specific bad request errors if needed
    }

    let errorKey = ApiErrorKeys.unknown;
    if (error.response?.status === 401) {
        if (error.response?.data?.type === 'user_not_found') {
            errorKey = ApiErrorKeys.userNotFound;
        } else if (error.response?.data?.type === "invalid_password") {
            errorKey = ApiErrorKeys.invalidPassword;
        } else {
            errorKey = ApiErrorKeys.unauthorized;
        }
    }

    return errorKey;
}

export const isUnavailableAuthError = (errorKey?: ErrorKey) => {
    return (
        errorKey?.code === ApiErrorKeys.networkError.code ||
        errorKey?.code === ApiErrorKeys.serviceUnavailable.code
    );
};